import "../../../css/DesignSystem/Inputs/InputField.css";

const InputField = ({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  multiline = false,
  rows = 3,
  error = false,
  helperText,
  required = false,
  disabled = false,
  icon,
  readOnly = false,
}) => {
  const inputId = id || `input-${label?.replace(/\s+/g, "-")?.toLowerCase()}`;
  const inputName = name || id;

  // Wrapper function to add name attribute to the event
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={`ds-input-field ${error ? "ds-input-field--error" : ""}`}>
      {label && (
        <div className="Content-Small" htmlFor={inputId}>
          {label}
          {required && <span className="ds-input-required">*</span>}
        </div>
      )}
      <div
        className={`Content ds-input-wrapper ${multiline ? "ds-input-wrapper--multiline" : ""}`}
      >
        {icon && <span className="ds-input-icon">{icon}</span>}
        {multiline ? (
          <textarea
            id={inputId}
            name={inputName}
            className="Content ds-input ds-input-textarea"
            rows={rows}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
          />
        ) : (
          <input
            id={inputId}
            name={inputName}
            className="Content ds-input ds-input-text"
            type={type}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
          />
        )}
      </div>
      {/* {helperText && (
        <div
          className={`ds-input-helper ${error ? "ds-input-helper--error" : ""}`}
        >
          {helperText}
        </div>
      )} */}
    </div>
  );
};

export default InputField;
